import { render, staticRenderFns } from "./PriceSettingsView.vue?vue&type=template&id=99e83af0&scoped=true&"
import script from "./PriceSettingsView.vue?vue&type=script&lang=ts&"
export * from "./PriceSettingsView.vue?vue&type=script&lang=ts&"
import style0 from "./PriceSettingsView.vue?vue&type=style&index=0&id=99e83af0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e83af0",
  null
  
)

export default component.exports